



























import EstimatePaymentMethodApi from "@/api/gateways/estimate-payment-method-api";
import { SaveServiceEstimatePaymentMethodCommand } from "@/api/project/estimate-payment-method-api";
import { client } from "@/api/request";
import { Component, Vue, Watch } from "vue-property-decorator";

const gw = new EstimatePaymentMethodApi(client);

@Component({})
export default class EstimatePaymentMethodFormPage extends Vue {
  goBack() {
    this.$router.push({ name: "project-property-estimate-payment-template" });
  }

  @Watch("$route.params.id", { immediate: true })
  onIdChanged(id: string | undefined) {
    this.load(id);
  }

  command: SaveServiceEstimatePaymentMethodCommand = {
    name: ""
  };

  async submit() {
    try {
      const cmd: SaveServiceEstimatePaymentMethodCommand = {
        name: this.command.name.trim()
      };
      if (this.$route.params.id) {
        cmd.id = Number(this.$route.params.id);
      }
      await gw.save(cmd);
      this.$router.replace({
        name: "project-property-estimate-payment-template"
      });
    } catch (e) {
      const msg =
        typeof e === "string"
          ? e
          : Array.isArray(e)
          ? e.join("\n")
          : "保存に失敗しました。";
      alert(msg);
    }
  }

  clickSubmitButton() {
    (this.$refs["btnSubmit"] as HTMLFormElement).click();
  }

  async load(id: string | undefined) {
    if (!id) {
      this.command = { name: "" };
      return;
    }
    const row = await gw.find(String(id));
    if (row) {
      this.command = { name: row.name, id: row.id };
    }
  }
}
